import { Text } from '../../../../../../../ToolkitV2/Text/Text';
import { Spacer } from '../../../../../../../../helpers/genericStyles';
import { ProgressBar } from '../../../../../../../ToolkitV2/ProgressBar/ProgressBar';

import { ARTIFICIAL_LOADING_TIME_LENGTH_IN_MILLISECONDS } from '../../../CarValuationTool.constants';

import { Container } from '../../subcomponents/Container/Container.styled';

const LoadingScreen = () => {
  return (
    <Container justifyContent="center">
      <Text size="L18" weight="semibold" color="GREY_DARK">
        Comparing your car to similar listings...
      </Text>
      <Spacer marginBottom="S8" />
      <ProgressBar
        animationDurationInMilliseconds={
          ARTIFICIAL_LOADING_TIME_LENGTH_IN_MILLISECONDS
        }
      />
    </Container>
  );
};

export { LoadingScreen };
